import React, { useState } from "react"
import moment from "moment"
import DatePicker from "react-datepicker"
import "./CalendarPicker.scss"
import "react-datepicker/dist/react-datepicker.css"
import Dropdown from "../../../DropDown"

export default function CalendarPicker({
  displayString,
  updateSelectedItem,
  selectedItem,
  selectedMode,
  updateSelectedMode,
  displayModes,

  dropdown,
  onDropdownChange,
}: any) {
  const modes = ["Day", "Week", "Month"]

  function handleChange(date: any) {
    let temp = moment(date).format("YYYY-MM-DD")
    toggleDatePicker(!datePickerIsOpen)
    updateSelectedItem(temp)
  }

  function onPrev() {
    const format =
      selectedMode === "Day"
        ? "days"
        : selectedMode === "Week"
          ? "weeks"
          : "months"
    const temp = moment(selectedItem).subtract(1, format)
    updateSelectedItem(moment(temp).format("YYYY-MM-DD"))
  }

  function onNext() {
    const format =
      selectedMode === "Day"
        ? "days"
        : selectedMode === "Week"
          ? "weeks"
          : "months"
    const temp = moment(selectedItem).add(1, format)
    const itemToUpdate = moment(temp).format("YYYY-MM-DD")
    updateSelectedItem(itemToUpdate)
  }

  const [datePickerIsOpen, toggleDatePicker] = useState<any>()

  return (
    <div className="col-md-12 col-lg-12 row calendar-picker-wrapper align-center">
      <div className="col-md-8 col-lg-8 p-0 d-flex align-center">
        <img
          className="iconButton cursor-pointer"
          alt="left arrow"
          src="../../assets/images/carouselLeftIcon.svg"
          onClick={() => onPrev()}
        />
        <div className="date-selected">{displayString}</div>
        <img
          className="iconButton cursor-pointer"
          alt="right arrow"
          src="../../assets/images/carouselRightIcon.svg"
          onClick={() => onNext()}
        />
        <img
          className="datepicker cursor-pointer"
          alt="datepicker icon"
          src="../../assets/images/datepickerIcon.svg"
          onClick={() => toggleDatePicker(!datePickerIsOpen)}
        />
        <DatePicker
          showMonthDropdown={selectedMode === "Month" ? true : false}
          selected={selectedItem ? new Date(selectedItem) : new Date()}
          onChange={(event: any) => handleChange(event)}
          onClickOutside={() => toggleDatePicker(!datePickerIsOpen)}
          open={datePickerIsOpen}
        />


        {/* {dropdown && dropdown?.displayDropdown && (
          <div className="col-md-4 col-lg-4 center-dropdown">
            <Dropdown
              selected={dropdown?.selected}
              placeholder="Select Center"
              options={dropdown?.dropdownValues}
              updateDropdown={(option: any) => onDropdownChange(option)}
            />
          </div>
        )} */}


      </div>
      {displayModes ? (
        <div className="col-md-4 col-lg-4 p-0 mode-selection d-flex align-center">
          {modes?.map((eachMode, index) => (
            <>
              <div
                className={`mode ${eachMode === selectedMode ? "selected" : "not-selected cursor-pointer"
                  }`}
                onClick={() => updateSelectedMode(eachMode)}
              >
                {eachMode}
              </div>
              {index !== modes?.length - 1 && (
                <div className="dividers">
                  <img alt="divider" src={"../../assets/images/divider.svg"} />
                </div>
              )}
            </>
          ))}
        </div>
      ) : null}
    </div>
  )
}
